module.exports = __webpack_public_path__ + "static/media/master-ic.933bd8cd.svg";